import chunk from 'lodash/chunk';

export const splitParagraphs = (
  html: string,
  chunkSize: number = 40
): string[] => {
  // 正規表現で<p>タグをマッチさせる
  const paragraphs = html.split(/\n\n/).filter((el) => el !== '');

  if (!paragraphs) {
    return [html];
  }

  return chunk(paragraphs, chunkSize).map((elements) => elements.join('\n'));
};
